import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./ErrorToast.css";

interface ErrorToastProps {
  message: string;
  onDismiss?: () => void;
}

export const ErrorToast: React.FC<ErrorToastProps> = ({ message, onDismiss }) => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    setIsVisible(true);
  }, [message]);

  const handleDismiss = () => {
    setIsVisible(false);
    setTimeout(() => {
      onDismiss?.();
    }, 300);
  };

  if (!message) return null;

  return (
    <div
      className={`error-toast ${isVisible ? "visible" : ""}`}
      role="alert"
      aria-live="assertive"
    >
      <div className="error-toast-content">
        <span className="error-toast-message">{message}</span>
        {onDismiss && (
          <button
            type="button"
            onClick={handleDismiss}
            className="error-toast-close"
            aria-label={t("errorToast.dismiss")}
          >
            ×
          </button>
        )}
      </div>
    </div>
  );
};

